<template>
  <div class="flex -mx-3">
    <div class="w-64 px-3">
      <RouterLink :to="productRoute">
        <template v-if="cover">
          <img
            v-if="cover"
            :srcset="cover.srcsets || ''"
            @load.once="onImageLoad"
            sizes="1px"
            :src="cover.url"
            class="block rounded w-full"
          />
        </template>
        <template v-else>
          <div class="aspect-ratio-16/9 w-full rounded bg-gray-200" />
        </template>
      </RouterLink>
    </div>
    <div class="flex-1 px-3 space-y-4">
      <RouterLink :to="productRoute">
        {{ product.name }}
        <div class="flex space-x-2 mt-2">
          <BaseBadge v-if="product.isBeta" purple> Beta </BaseBadge>
          <BaseBadge v-if="!product.publishedAt" silver> Unpublished </BaseBadge>
        </div>
      </RouterLink>
      <p class="text-muted text-sm">
        {{ product.description }}
      </p>
    </div>
    <div class="w-24 px-3 text-right">
      {{ product.price }}
    </div>
  </div>
</template>

<script>
import mediableMixin from '@/mixins/mediableMixin';

export default {
  name: 'DataIteratItem',
  mixins: [mediableMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
    productRouteName: {
      type: String,
      required: true,
    },
  },
  computed: {
    productRoute() {
      return {
        name: this.productRouteName,
        params: { ...this.$route.params, productId: this.product.id },
      };
    },
    cover() {
      const { media = [] } = this.product || {};
      return media.find((item) => item.collection === 'images') || null;
    },
  },
};
</script>
